import React from 'react';
import './App.css';
import Home from './Home';
import Ctc from './CTCBreakupCalculator';
import 'bootstrap/dist/css/bootstrap.min.css';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

function App() {
  return (
    <>
    <Router>
      <Routes>
      <Route exact path="/" element={<Home />}/>
      <Route exact path="/ctc" element={<Ctc />}/>
      <Route path="*" element={<Navigate to="/" />}/>
      </Routes>
    </Router>
    </>
  );
}

export default App;